module.exports = __webpack_public_path__ + "static/course_event-loop-js-b676be37950184af3fa8aec1569da0ad.svg";